import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const overviewPlugin = createPlugin({
  id: 'overview',
  routes: {
    root: rootRouteRef,
  },
});

export const OverviewPage = overviewPlugin.provide(
  createRoutableExtension({
    name: 'OverviewPage',
    component: () =>
      import('./components/OverviewComponent').then(m => m.OverviewComponent),
    mountPoint: rootRouteRef,
  }),
);
